/** Подтверждение кассира, PIN и политики — служба Cashiers (RP-SEP1); через шлюз `/api/cashiers/**`. */
const ROOT = '/api/cashiers/v1'
export const CASHIER_ACCESS_URLS = {
  settings: `${ROOT}/settings`,
  reset: `${ROOT}/settings/reset`,
  revoke: `${ROOT}/settings/revoke`,
  sources: `${ROOT}/sources`,
  sourcePolicy: (id: string) => `${ROOT}/sources/${encodeURIComponent(id)}/policy`,
  cashiers: `${ROOT}/cashiers`,
  verify: `${ROOT}/verify`,
  sessionHeartbeat: `${ROOT}/sessions/heartbeat`,
  sessionEnd: `${ROOT}/sessions/end`,
  sessionsMine: `${ROOT}/sessions/mine`,
  sessionRevoke: `${ROOT}/sessions/revoke`,
  lockouts: `${ROOT}/security/lockouts`,
  unlock: `${ROOT}/security/unlock`,
  invitations: `${ROOT}/security/invitations`,
  redeem: `${ROOT}/invitations/redeem`,
  accessSummary: (id: string) => `${ROOT}/sources/${encodeURIComponent(id)}/access-summary`,
  policy: `${ROOT}/policy`,
  rmkSettings: `${ROOT}/rmk-settings`,
  rmkOptions: `${ROOT}/rmk-settings/options`,
  identifiedHere: `${ROOT}/identifications/here`,
} as const
